import {
  AnnotationCommon,
  BoundingHighlightRectsData,
  BoundingRectData,
  CommonData,
  CommonShapeData,
  ShapeAnnotationData,
} from '../types';

export interface TextHighlightAnnotation extends AnnotationCommon {
  location: {
    pageNumber: number;
    range: string;
  };
  type: 'Text';
  text?: string;
  data?: undefined;
}

export interface PDFTextHighlightAnnotation
  extends AnnotationCommon,
    CommonData {
  location: {
    pageNumber: number;
  };
  type: 'Text';
  text?: string;
  data?: BoundingHighlightRectsData & CommonData['data'];
}

export interface MediaAnnotation extends AnnotationCommon, CommonData {
  type: 'Media';
  data: BoundingRectData &
    CommonData['data'] & {
      url: string;
      variant: 'Embedded' | 'Icon';
    };
}

export interface HtmlAnnotation extends AnnotationCommon, CommonData {
  type: 'HTML';
  data: BoundingRectData &
    CommonData['data'] & {
      html: string;
      variant: 'Embedded' | 'Icon';
    };
}

export interface ImageAnnotation extends AnnotationCommon, CommonData {
  type: 'Image';
  data: BoundingRectData &
    CommonData['data'] & {
      url: string;
    };
}

export interface RectangleAnnotation extends AnnotationCommon, CommonData {
  type: 'Rectangle';
  data: BoundingRectData &
    CommonShapeData &
    ShapeAnnotationData &
    CommonData['data'];
}

export interface OverlayAnnotation extends AnnotationCommon, CommonData {
  type: 'OverlayText';
  data: BoundingRectData &
    CommonShapeData &
    CommonData['data'] & {
      text: string;
      lineHeight: number;
      overflowWrap: 'break-word' | 'normal';
      wordBreak: 'break-all' | 'keep-all' | 'normal';
      textAlign: 'center' | 'left' | 'right';
      fontFamily: string;
      fontSize: number;
      fontWeight: number;
    };
}

export interface CircleAnnotation extends AnnotationCommon, CommonData {
  type: 'Circle';
  data: BoundingRectData &
    CommonShapeData &
    ShapeAnnotationData &
    CommonData['data'];
}

export interface Point {
  x: number;
  y: number;
}

export interface Path {
  points: Point[];
}

export interface PathAnnotation extends AnnotationCommon, CommonData {
  type: 'Path';
  data: BoundingRectData &
    CommonData['data'] & {
      stroke: string;
      strokeWidth: number;
      paths: Path[];
    };
}

export type Annotation =
  | MediaAnnotation
  | HtmlAnnotation
  | ImageAnnotation
  | RectangleAnnotation
  | CircleAnnotation
  | OverlayAnnotation
  | PathAnnotation
  | TextHighlightAnnotation
  | PDFTextHighlightAnnotation;

export type EnhancedAnnotation = Exclude<
  Annotation,
  TextHighlightAnnotation | PDFTextHighlightAnnotation
>;

export const OverlayAnnotationTypes = [
  'Media',
  'HTML',
  'Image',
  'Rectangle',
  'Circle',
  'OverlayText',
  'Path',
];
